import { render, staticRenderFns } from "./editGroup.vue?vue&type=template&id=5c661d03&lang=pug"
import script from "./editGroup.vue?vue&type=script&lang=js"
export * from "./editGroup.vue?vue&type=script&lang=js"
import style0 from "./editGroup.vue?vue&type=style&index=0&id=5c661d03&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports